<template>
    <div v-if="membershipPlan && isFillInformationStepActive">
        <card class="p-0 rounded-lg" id="information-panel-event">

            <!-- Main Section Title -->
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('online_booking.sidebar.your_details') }}
            </h4>

            <div
                id="collapseFillSubscriptionInfo"
                role="tabpanel"
                aria-labelledby="headingFillEventInfo"
                data-parent="#event-accordion"
            >
                <form id="fill-info-frm" role="form" @submit.prevent="infoAdded()">
                    <div class="panel-body pb-0">
                        <div class="row">
                            <div class="col-xs-12">
                                <client-form
                                    class="online-booking-client-form"
                                    v-if="!logged_in_client"
                                    v-model="form"
                                    :nameOptions="{ display: true, required: true }"
                                    :emailOptions="{ display: true, required: true}"
                                    :phoneOptions="{ display: false, required: false }"
                                    :addressOptions="{ display: true, required: true }"
                                    :dobOptions="{ display: false, required: false }"
                                    :cprOptions="{ display: false, required: false }"
                                    :validationErrors="errors"
                                    show-required-indicator
                                >
                                </client-form>

                                <!-- Alert - Already logged in -->
                                <div class="alert alert-info mb-6" v-if="logged_in_client">
                                    <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                                    <span>{{ trans('online_booking.logged_in_as') }}</span>&nbsp;<strong>{{ logged_in_client.name }}</strong>
                                </div>
                                <!-- End of Alert -->

                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between p-6 pt-0">
                        <router-link
                            :to="{ name: 'membership-plan', params: { slug: $route.params.slug } }"
                            class="btn btn-brand btn-trans"
                        >
                            <i class="zmdi zmdi-arrow-left"></i>
                            <span class="hidden-xs ml-3">{{ trans('global.back') }}</span>
                        </router-link>
                        <ep-button
                            :loading="loading"
                            :disabled="loading"
                            type="submit"
                        >
                            <span class="hidden sm:inline">{{trans('online_booking.continue_to_confirmation') }}</span>
                            <span class="sm:hidden">{{ trans('global.continue') }}</span>
                            <i class="zmdi zmdi-arrow-right ml-3"></i>
                        </ep-button>

                    </div>
                </form>
            </div>
        </card>
    </div>
</template>


<script>
import { http } from '@/system/http';
import Switchery from '@/system/components/global/form/Switchery';
import ClientForm from '@/online_booking/new/components/common_booking/ClientForm.vue';
import Card from '@/online_booking/new/components/common/Card';
import StepCounter from '@/online_booking/new/components/common/StepCounter';
import {mapGetters, mapActions, mapState} from 'vuex';
import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
import EpButton from '@/system/components/global/button';
import { bookingKeys } from '@/online_booking/new/helpers/constants';

export default {
    data() {
        return {
            loading: false,
            logged_in_client: false,
            online_booking_settings: null,
            user: {},
            membershipPlan: null,
            slug: null,
            form: {
                name: '',
                email: '',
                phone: '',
                city: '',
                zip: '',
                zone: '',
                country: '',
                notes: ''
            }
        };
    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),

        infoAdded() {
            this.errors.clear();
            this.loading = true;
            const dataFrm = new FormData($('#fill-info-frm')[0]);

            Object.keys(this.form).forEach((property) => {
                dataFrm.append(property, this.form[property])
            })

            http.post('/subscription/' + this.slug + '/is-choose-client', dataFrm)
                .then(({ data }) => {
                    var confirmInfo = null;

                    if (this.logged_in_client) {
                        confirmInfo = {
                            name: this.logged_in_client.name,
                            email: this.logged_in_client.email,
                            phone: this.logged_in_client.phone,
                            address: this.logged_in_client.address,
                            address_line_2: this.logged_in_client.address_line_2,
                            zip: this.logged_in_client.zip,
                            city: this.logged_in_client.city,
                            zone: this.logged_in_client.zone,
                            country: this.logged_in_client.country,
                            notes: this.form.notes,
                        };
                    } else {
                        confirmInfo = confirmInfo = Object.assign({}, this.form)
                    }

                    if (data.choose_client) {
                        this.$event_bus.$emit('chooseCourseUser', {
                            dataFrm: dataFrm,
                            clients: data.data.clients,
                            confirmInfo: confirmInfo,
                        });
                    } else {
                        dataFrm.append('client', data.client);
                        this.$event_bus.$emit('confirmMembershipPlan', {
                            dataFrm: dataFrm,
                            confirmInfo: confirmInfo,
                        });
                    }

                    this.loading = false;
                })
                .catch(({ errorBag }) => {
                    this.loading = false;
                    this.$setErrorBag(errorBag);

                    if (errorBag && errorBag.items && errorBag.items.length > 0) {
                        let fieldName = errorBag.items[0].field.split('.').pop();
                        $('[name=' + fieldName + ']').focus();
                    }
                });
        },
    },

    mounted() {
        this.slug = this.$route.params.slug;

        this.$event_bus.$on('LoadMembershipData', data => {
            this.user = data.user;
            this.membershipPlan = data.membership_plan;
            this.logged_in_client = data.logged_in_client;
            this.online_booking_settings = data.online_booking_settings;
            this.setCurrentStep('fillInformation');
            this.setSelectedValue({
                key: bookingKeys.FILL_INFORMATION,
                value: data.logged_in_client ? data.logged_in_client.name : ''
            });
        });
    },

    computed: {
        ...mapState('OnlineBooking', ['currentStep']),
        ...mapGetters('OnlineBooking', ['currentStepNumber', 'totalStepCount', 'getPreviousStepId']),

        isFillInformationStepActive () {
            return this.currentStep === 'fillInformation';
        }
    },

    watch: {
        'membershipPlan.name' (newValue) {
            if (newValue) {
                this.setSelectedValue({
                    key: bookingKeys.SUBSCRIPTION_INFO,
                    value: `${this.trans('apps.memberships.subscribe')} "${this.membershipPlan.name}"`
                });
            }
        },

        'form.name' (newValue) {
            // to make sure sidebar has the details of the client if they are NOT logged in
            this.setSelectedValue({
                key: bookingKeys.FILL_INFORMATION,
                value: newValue ? newValue : ''
            });
        },
    },

    components: {
        PreviousButton,
        ClientForm,
        Switchery,
        Card,
        StepCounter,
        EpButton,
    },
};
</script>
